import React, { useEffect, useMemo } from 'react';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { OverlayComponent } from 'app/components';
import { hasChanges } from '../utils/has-changes';
import { activeItemSelected } from '../utils/selected-value';
import { userMembersTranslation } from '../constants';
import {
  useDetailsSelectors, useListActionsSelectors, useListBranchSelectors
} from '../hooks';
import { UserMembersHeader } from './user-members-header';
import { UserMembersErrors } from './user-members-errors';
import { UserMembersPrompt } from './user-members-prompt';
import { UserMembersResults } from './user-members-results';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { RouterProps } from 'app/components/enhancers/with-router';
import styles from './user-members-list.scss';

interface UserMembersListProps {
  id: string;
  router: RouterProps;
}

export const UserMembersList: React.FC<UserMembersListProps> = ({ id, router }) => {

  const subscriberGroupId = parseInt(id, 10);
  const { listBranch } = useListBranchSelectors();
  const { listActions, updating, activeValueError } = useListActionsSelectors();
  const { activeValue } = useDetailsSelectors();

  const shouldPrompt = useMemo(
    () => hasChanges(listBranch, listActions, activeItemSelected(activeValue)),
    [listBranch, listActions, activeValue?.value]
  );

  const translation = useTranslation(STATE.subscriberGroups, userMembersTranslation);

  useEffect(() => {
    scrollToTop();
  }, []);

  return <>
    <UserMembersPrompt
      router={router}
      shouldPrompt={shouldPrompt}
      translation={translation} />
    <UserMembersErrors
      translation={translation} />
    <OverlayComponent
      displayOverlay={updating}
      overlayText={translation.message_updating} />
    <div className={styles.header}>
      <MainGridContainer>
        <UserMembersHeader
          id={subscriberGroupId}
          shouldPrompt={shouldPrompt}
          activeValueError={activeValueError}
          translation={translation} />
      </MainGridContainer>
    </div>
    <div className={styles.body}>
      <MainGridContainer>
        <UserMembersResults
          subscriberGroupId={subscriberGroupId}
          hasChanges={shouldPrompt}
          translation={translation} />
      </MainGridContainer>
    </div>
  </>;
};
